import { render } from "./EventTypeLabel.vue?vue&type=template&id=77b451e2"
import script from "./EventTypeLabel.vue?vue&type=script&lang=js"
export * from "./EventTypeLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__